import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7593 6.80289C11.7594 7.78318 11.4689 8.74149 10.9243 9.55663C10.3798 10.3718 9.60573 11.0071 8.70009 11.3823C7.79445 11.7575 6.79788 11.8558 5.83641 11.6646C4.87494 11.4734 3.99176 11.0014 3.29855 10.3083C2.60534 9.61515 2.13324 8.73202 1.94196 7.77057C1.75067 6.80912 1.84879 5.81254 2.22391 4.90686C2.59902 4.00117 3.23429 3.22707 4.04936 2.68244C4.86444 2.1378 5.82272 1.84711 6.80301 1.84711C8.11742 1.84711 9.37799 2.36921 10.3075 3.29859C11.2369 4.22796 11.7592 5.48848 11.7593 6.80289Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.30859 6.76898H9.23047",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3076 10.3073L14.1516 14.1518",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgZoomOut;
